// ── Backlog sprint-rail target derivation (TPT43) ──
// Pure, DOM-free — the rail's drop targets for a given sprints/tasks pair. Labels are NOT
// applied here (the caller has the resolved noun and sprintLabel()); this returns the shape.
import { sprintFilterNumbers } from '../components/board-filters.js';
import { nextSprintNumber } from '../utils.js';

export function railTargets(sprints, tasks) {
  const list = sprintFilterNumbers(sprints, tasks)
    // sprintFilterNumbers appends 0 (Backlog) whenever ANY task sits at priority 0 — which
    // on this page is nearly always true and is exactly where the dragged row already is.
    // "Move to Backlog" from the Backlog is a no-op, so 0 is never a target.
    .filter(n => n > 0)
    .map(n => ({
      number: n,
      // Closed sprints stay droppable, dimmed — matches the filter bar's closed options.
      // A number in use by tasks with no sprints row (linkage is convention-only, no FK)
      // has no status and reads as active.
      closed: (sprints || []).some(s => s.number === n && s.status === 'closed'),
      isNew: false,
    }));
  // Trailing "+ New <Singular>" — same number the page's own `+ New` <option> uses
  // (nextSprintNumber). Strictly greater than every number above, so it never duplicates one.
  list.push({ number: nextSprintNumber(sprints, tasks), closed: false, isNew: true });
  return list;
}
